module.exports = __webpack_public_path__ + "img/icon-pinned.f1a138be.svg";